import React, { useState } from "react";
import { useDrag, useDrop } from 'react-dnd';
import { Button, Image } from "react-bootstrap";
import Popup from "reactjs-popup";

// Constants
import colors from "../../../../utils/colors";

// Images
import verticalContainerImg from "../../../../assets/images/container-v.png";
import green from "../../../../assets/images/tiled-green-card.png";
import yellow from "../../../../assets/images/tiled-yellow-card.png";
import blue from "../../../../assets/images/tiled-blue-card.png";
import red from "../../../../assets/images/tiled-red-card.png";
import DraggableCoin from "../../Common/DraggableCoin";

export default function DroppableDirectCostField(props) {
	const [showUnitsPopup, setShowUnitsPopup] = useState(false);
	const [soldUnites, setSoldUnites] = useState(0);
	const [item, setItem] = useState(null);

	const [{ isOver, canDrop }, drop] = useDrop({
		accept: ['StockContainer', 'DirectCostContainer'],
		collect: (monitor) => ({
			isOver: monitor.isOver(),
			canDrop: monitor.canDrop(),
		}),
		drop: (item) => {
			if (item.type === 'DirectCostContainer') {
				props.appendDirectCostContainer(item);
				return item;
			}

			setItem(item);
			setShowUnitsPopup(true);


			return item;
			/*let soldNumber = prompt("How many did you sell?", "0");
			if (soldNumber) {
				props.appendContainer(item.coins, item.hasCard, soldNumber, item.cardColor, item.cardValue, item.id);
			}*/

			//return undefined;
		},
	})

	const [{ isDragging }, drag] = useDrag({
		item: {
			type: 'DirectCostContainer',
			coins: props.data.coins,
			hasCard: props.data.hasCard,
			cardValue: props.data.cardValue,
			cardColor: props.data.cardColor,
			id: props.id,
		},
		collect: (monitor) => ({
			isDragging: monitor.isDragging(),
		}),
		end: (item, monitor) => {
			if (monitor.didDrop()) {
				props.removeContainer();
			}
		},
	});

	const backgroundColor = (isOver && canDrop) ? colors.activeBackground : ""
	const canPlayerDrop = (props.canEdit) ? drop : null;
	const canPlayerDrag = (props.canEdit) ? drag : null;
	const [isHover, setIsHover] = useState(false);
	const coinsTotal = props.data.coins.reduce((a, b) => a + b, 0);


	return (
		<>
			<div className="sold-units-popup">
				{
					(showUnitsPopup) ?
						<Popup
							open
							modal
							onClose={() => setShowUnitsPopup(false)}
						>
							<>
								<div className="popup-header">
									Confirmation required!
								</div>
								<div className="popup-body">
									<div>How many units did you sell?</div>
									<input autoFocus type="text" id="units" name="units" onChange={e => setSoldUnites(parseInt(e.target.value))} />
									<Button size="sm" onClick={(e) => {
										if (soldUnites <= parseInt(item.cardValue)) {
											props.appendContainer(item.coins, item.hasCard, soldUnites, item.cardColor, item.cardValue, item.id);
											setShowUnitsPopup(false);
										}
									}}>Confirm</Button>
								</div>
							</>
						</Popup>
						:
						null
				}
			</div>
			{
				(props.data.hasContainer) ?
					<div className={"coins-sum"} onMouseEnter={() => setIsHover(true)} onMouseLeave={() => setIsHover(false)}>
						<div
							className="coins-sum"
							style={
								isHover && props.data.coins
									? { display: "block" }
									: { display: "none" }
							}
						>
							<p style={{ color: "#d1d1d1", margin: 0 }}>{coinsTotal}</p>
						</div>
						<div className="Vertical-droppable-field">
							<div
								className={`containerObjClass${isDragging ? " dragging" : ""}`}
								ref={canPlayerDrag}
							>
								<Image className="objModelClass" src={verticalContainerImg} />
								<div className="Coins-vertical-droppable">
									{
										(props.data.coins.map((value, index) => {
											return (
												<DraggableCoin
													canEdit={props.canEdit}
													coinDraggingIndex={-1}
													draggingType=""
													id={props.id}
													index={index}
													isDraggingHandler={props.isDraggingHandler}
													isLastCoin={props.data.coins.length === index + 1 && (index + 1) % 5 === 0}
													key={index}
													playerId={props.data.playerId}
													removeCoin={props.removeCoin}
													value={value}
												/>
											)
										}))
									}
									{
										(props.data.hasCard && props.data.cardType === "label") ?
											<div className="containerProductCardDraggable">
												{(
													(props.data.cardColor === "standard" &&
														<Image className="containerProductCardDraggableImg" src={green} />)
													|| (props.data.cardColor === "compact" &&
														<Image className="containerProductCardDraggableImg" src={yellow} />)
													|| (props.data.cardColor === "plus" &&
														<Image className="containerProductCardDraggableImg" src={blue} />)
													|| (props.data.cardColor === "luxus" &&
														<Image className="containerProductCardDraggableImg" src={red} />)
												)}
												{
													(props.data.cardValue > 0) ?
														<div className="containerProductCardValue">{props.data.cardValue}</div>
														:
														null
												}
											</div>
											:
											null
									}
								</div>
							</div>
						</div>
					</div>
					:
					<div className="Vertical-droppable-field" style={{ backgroundColor: backgroundColor }} ref={canPlayerDrop}></div>
			}
		</>
	);
}
